import * as React from "react";
import { forwardRef } from "react";
const SvgHome = (props, ref) => /* @__PURE__ */ React.createElement("svg", { width: 20, height: 20, viewBox: "0 0 30 30", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref, ...props }, /* @__PURE__ */ React.createElement("path", { d: "M15 2.62451L1.25 15H5V26.25H12.5V18.75H17.5V26.25H25V15H28.75L15 2.62451Z", fill: "currentColor" }));
const ForwardRef = forwardRef(SvgHome);
export default ForwardRef;
